import { CHARACTER, WORD } from './consts'
import { isNil, map, pipe } from 'rambda'

/**
 * Builds diff between 2 provided objects.
 * Used to create green/red comparisons of existing/different values.
 * */
export default (original, incoming) => pipe(
  map(
    (value, key) => {
      const diffs = key in keyDiffs
        ? keyDiffs[key](original[key], value)
        : null

      return {
        diffs,
        value,
        valueOriginal: original[key],
      }
    },
  ),
)(incoming)

const keyDiffs = {
  batteryWh: exact,
  cpu: byCharacter,
  gpu: byCharacter,
  hasBacklight: exact,
  hasNumpad: exact,
  hasNvme: exact,
  hddAmount: exact,
  memoryAmount: exact,
  name: byWord,
  portsDisplayPort: exact,
  portsHdmi: exact,
  portsThunderbolt: exact,
  portsUsb2: exact,
  portsUsb3a: exact,
  portsUsb3c: exact,
  portsUsb4: exact,
  resolution: exact,
  screen: byWord,
  screenContrast: exact,
  screenHz: exact,
  screenNits: exact,
  screenP3: exact,
  screenRgb: exact,
  screenSrgb: exact,
  ssdAmount: exact,
  weight: exact,
}

function exact(original, incoming) {
  return [{
    theme: getTheme(original, incoming),
    value: incoming,
    valueOriginal: original,
    type: WORD,
  }]
}

function byCharacter(original, incoming) {
  const originalCharacters = (original || '').split('')

  return (incoming || '')
    .split('')
    .map((character, index) => ({
      theme: getTheme(originalCharacters[index], character),
      value: character,
      valueOriginal: originalCharacters[index],
      type: CHARACTER,
    }))
}

function getTheme(original, incoming) {
  if (original === incoming) return 'info'

  if (
    typeof original === 'string' &&
    typeof incoming === 'string' &&
    original.toLowerCase() === incoming.toLowerCase()
  ) return 'info'

  if (isNil(original) && !isNil(incoming)) return 'success'

  return 'danger'
}

const separators = /[ -]/
function byWord(original, incoming) {
  const originalWords = (original || '')
    .split(separators)

  return (incoming || '')
    .split(separators)
    .map((word, index) => ({
      theme: getTheme(originalWords[index], word),
      value: word,
      valueOriginal: originalWords[index],
      type: WORD,
    }))
}
